<template>
    <div class="forgetPassword">
        <header>
            <nav class="site-navbar">
                <div class="site-navbar__header" style="width: 500px;">
                    <h1 class="site-navbar__brand" @click="$router.push({ name: 'home' })">
                        <a class="site-navbar__brand-lg" href="javascript:;"><span style="padding-left: 10px">黄石市公共资源交易主体库</span></a>
                        <a class="site-navbar__brand-mini" href="javascript:;"><img src="~@/assets/img/logo.png" style="height: 34px;" alt=""></a>
                    </h1>
                </div>
            </nav>
        </header>
        <el-card class="box-card">
            <nav>
                <stepCom ref="stepsChild" :stepsData="stepsData" :stepsIndex="active" />
            </nav>
            <main>
                <div v-if="active == 0" class="accountInformation">
                    <div class="accountInformation_title"><p>忘记密码</p></div>
                    <span>请输入登录帐号/统一社会信用代码(身份证号)</span>
                    <div class="selectType">
                        <el-radio-group @change="selectRadio" v-model="idType">
                            <el-radio label="1">登录账号</el-radio>
                            <el-radio label="2">统一社会信用代码（身份证号）</el-radio>
                        </el-radio-group>
                    </div>
                    <el-input :class="adopt == true ? 'activeInput' : ''" style="margin-left: 16px;" v-model="input" @change="checkInputRule" :placeholder="idType == 1 ? '请输入登录账号' : '请输入统一社会信用代码（身份证号）'" size="small"></el-input>
                    <span v-if="adopt == true" class="checkTip">{{idType == 1 ? '请输入登录账号' : '请输入统一社会信用代码（身份证号）'}}</span>
                </div>
                <div v-if="active == 1" class="checkInformation">
                    <div class="checkInformation_title"><p>忘记密码</p></div>
                    <span>{{sms == true ? `请输入${codeNumber}收到的短信验证码` : '请输入预留手机号中间四位'}}</span>
                    <div v-if="sms == false" class="phoneNumber">
                        <span>{{ frontNumber }}</span>
                        <!--手机号中间四位输入框-->
                        <input v-model="phoneNumber1" ref="phoneNumber1" @keydown.8="deleteValue('phoneNumber1','phoneNumber1')" @keyup="changeValue($event,'phoneNumber1','phoneNumber2')">
                        <input v-model="phoneNumber2" ref="phoneNumber2" @keydown.8="deleteValue('phoneNumber2','phoneNumber1')" @keyup="changeValue($event,'phoneNumber2','phoneNumber3')">
                        <input v-model="phoneNumber3" ref="phoneNumber3" @keydown.8="deleteValue('phoneNumber3','phoneNumber2')" @keyup="changeValue($event,'phoneNumber3','phoneNumber4')">
                        <input v-model="phoneNumber4" ref="phoneNumber4" @keydown.8="deleteValue('phoneNumber4','phoneNumber3')" @keyup="changeValue($event,'phoneNumber4','phoneNumber4')">
                        <span style="margin-left: 16px;">{{ afterNumber }}</span>
                    </div>
                    <span v-if="phoneNumberRule == true" class="phoneNumberRule">{{ tipCont }}</span>
                    <div  v-if="sms == true" class="phoneNumber" style="margin-top: 26px;">
                        <!--短信验证码输入框-->
                        <input v-model="checkNumber1" ref="checkNumber1" @keydown.8="deleteValue('checkNumber1','checkNumber1')" @keyup="changeValue($event,'checkNumber1','checkNumber2')">
                        <input v-model="checkNumber2" ref="checkNumber2" @keydown.8="deleteValue('checkNumber2','checkNumber1')" @keyup="changeValue($event,'checkNumber2','checkNumber3')">
                        <input v-model="checkNumber3" ref="checkNumber3" @keydown.8="deleteValue('checkNumber3','checkNumber2')" @keyup="changeValue($event,'checkNumber3','checkNumber4')">
                        <input v-model="checkNumber4" ref="checkNumber4" @keydown.8="deleteValue('checkNumber4','checkNumber3')" @keyup="changeValue($event,'checkNumber4','checkNumber5')">
                        <input v-model="checkNumber5" ref="checkNumber5" @keydown.8="deleteValue('checkNumber5','checkNumber4')" @keyup="changeValue($event,'checkNumber5','checkNumber6')">
                        <input v-model="checkNumber6" ref="checkNumber6" @keydown.8="deleteValue('checkNumber6','checkNumber5')" @keyup="changeValue($event,'checkNumber6','checkNumber6')">
                    </div>
                    <span v-if="checkNumberRule == true" class="checkNumberRule">请输入正确的验证码</span>
                    <span v-if="sms == true" style="display: inline;margin-left: 305px;font-size: 12px;color: rgba(0, 0, 0, 0.85);">未收到的短信验证码？
                        <span v-if="isSend" @click="againSendCode" style="color: #1890FF;font-size: 14px;cursor: pointer;margin-left: 8px;">重新发送</span>
                        <span v-if="!isSend" style="color: #999;font-size: 14px;cursor: pointer;margin-left: 8px;">请 {{count}}s 后再试</span>
                    </span>
                </div>
                <div v-if="active == 2 && result == false" class="changeformation">
                    <div class="changeformation_title"><p>忘记密码</p></div>
                    <span>请重新设置密码</span>
                    <el-form style="margin: 28px 100px 40px;" label-width="140px" :model="form" ref="form" :rules="rules">
                        <el-form-item label="新密码：" prop="pwd">
                            <el-input v-model="form.pwd" size="small" show-password placeholder="请输入密码"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码：" prop="checkpwd">
                            <el-input v-model="form.checkpwd" size="small" show-password placeholder="请再次输入密码"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-if="result == true" class="resultPage">
                    <span><img src="../../../src/assets/img/login/result_success.png"></span>
                    <p>提交成功</p>
<!--                    已重新设置密码，请重新登录-->
                    <el-button type="primary" @click="goBack" size="small">返回登录</el-button>
                </div>
            </main>
            <footer class="Btn">
                <el-button v-if="active == 0" @click="goBack" size="small">返回</el-button>
                <el-button v-if="active == 0" type="primary" @click="next" size="small">下一步</el-button>
                <el-button v-if="active == 1" @click="goBackCheck" size="small">上一步</el-button>
                <el-button v-if="active == 1 && sms == false" type="primary" @click="nextCheck" size="small">下一步</el-button>
                <el-button v-if="active == 1 && sms == true" type="primary" @click="nextCheckCode" size="small">下一步</el-button>
                <el-button v-if="active == 2 && result == false" type="primary" @click="submit('form')" size="small">提交</el-button>
            </footer>
        </el-card>
        <div style="height: 40px"></div>
    </div>
</template>

<script>
    export default {
        name: "forgetPassword",
        data() {
            // 密码校验
            let validatePass = (rule, value, callback) => {
                let reg= /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/;
                if (!reg.test(value)) {
                    callback(new Error('密码必须是数字+字母且不少于8位数！'));
                } else {
                    if (this.form.checkpwd !== '') {
                        this.$refs.form.validateField('checkpwd');
                    }
                    callback();
                }
            };
            // 确认密码
            let validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.form.pwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                actionId:'',
                active: 0,
                idType: '1',
                tipCont:'',
                input:'',
                phoneNumbers:'', // 完整手机号
                frontNumber:'', // 手机号前3位
                afterNumber:'', // 手机号后四位
                codeNumber:'', // 中间*的手机号
                phoneNumber1:'',
                phoneNumber2:'',
                phoneNumber3:'',
                phoneNumber4:'',
                checkNumber1:'',
                checkNumber2:'',
                checkNumber3:'',
                checkNumber4:'',
                checkNumber5:'',
                checkNumber6:'',
                sms:false,
                result:false,
                adopt:false,
                phoneNumberRule:false,
                checkNumberRule:false,
                form:{
                    pwd:'',
                    checkpwd:''
                },
                rules: {
                    pwd: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    checkpwd: [
                        { required: true, validator: validatePass2, trigger: 'blur' }
                    ]
                },
                count:'',
                isSend: true,
                timer:null,
                stepsData:[
                    {name:'输入账号信息'},
                    {name:'验证信息'},
                    {name:'更改密码'},
                ]
            }
        },
        components:{

        },
        created() {

        },
        methods: {
            selectRadio() {
              this.input = '';
            },
            deleteValue (inputValue, previousItem) { // 键盘按下时$event，当前input，上一个input
                if (this[inputValue].length > 0) { // 当前有值，清空之
                    this[inputValue] = ''
                } else { // 当前没有值，光标跳转到上一个input，并清空该input值
                    this.$nextTick(() => {
                        this.$refs[previousItem].focus()
                        this[previousItem] = ''
                        this[inputValue] = ''
                    })
                }
            },
            changeValue (e, inputValue, nextItem) { // 键盘抬起时$event，当前input，下一个input
                if (e.keyCode !== 8) {
                    this.$nextTick(() => {
                        this.$refs[nextItem].focus() // 截取当前值最后一位，跳到下一个input
                        this[inputValue] = (this[inputValue]).toString().slice(-1)
                    })
                }
            },
            // 不同意
            goBack() {
                this.$router.go(-1);
            },
            // 下一步
            next() {
                let params = {};
                if(!!this.input){
                    if(this.idType == 1){
                        params.loginName = this.input;
                    }else if(this.idType == 2){
                        params.mainCodeOrIdcard = this.input;
                    }
                    this.$http.post('/get/loginUser',params).then((res) => {
                        if(res.data && res.data.code == 1){
                            this.actionId = res.data.data.id;
                            this.phoneNumbers = res.data.data.linkPhone;
                            this.frontNumber = res.data.data.linkPhone.substring(0,3).split('').join(' ');
                            this.afterNumber = res.data.data.linkPhone.substring(res.data.data.linkPhone.length-4,res.data.data.linkPhone.length).split('').join(' ');
                            this.codeNumber = res.data.data.linkPhone.substr(0,3) + "****" + res.data.data.linkPhone.substr(7);
                            this.adopt = false;
                            this.active++;
                        }else{
                            this.$notify({
                                title: '账号信息',
                                message: res.data.msg,
                                position: 'bottom-right',
                                type: 'warning'
                            })
                        }
                    });
                }else{
                    this.adopt = true;
                }
            },
            // 上一步
            goBackCheck() {
                if(this.sms == true){
                    this.sms = false;
                }else{
                    this.active--;
                }
            },
            // 下一步(验证信息)
            nextCheck() {
                // 获取的手机中间四位
                let ruleNumber = this.phoneNumbers.substring(this.phoneNumbers.length-8,this.phoneNumbers.length-4);
                // 输入的手机号中间四位
                let inputNumber = this.phoneNumber1+this.phoneNumber2+this.phoneNumber3+this.phoneNumber4;
                if(!!this.phoneNumber1 && !!this.phoneNumber2 && !!this.phoneNumber3 && !!this.phoneNumber4){
                    if(ruleNumber == inputNumber){
                        this.$http.post('/register/getSms',{
                            linkPhone: this.phoneNumbers
                        }).then((res) => {
                            if(res.data && res.data.code == 1){
                                this.sms = true;
                            }else{
                                this.$notify({
                                    title: '发送验证码',
                                    message: res.data.msg,
                                    position: 'bottom-right',
                                    type: 'warning'
                                })
                            }
                        });
                        this.phoneNumberRule = false;
                    }else{
                        this.tipCont = '请输入正确的手机号';
                        this.phoneNumberRule = true;
                    }
                }else{
                    this.tipCont = '请输入手机号中间四位';
                    this.phoneNumberRule = true;
                }
            },
            // 确认验证码
            nextCheckCode() {
                let checkNumber = this.checkNumber1+this.checkNumber2+this.checkNumber3+this.checkNumber4+this.checkNumber5+this.checkNumber6;
               if(this.sms == true && !!this.checkNumber1 && !!this.checkNumber2 && !!this.checkNumber3 && !!this.checkNumber4 && !!this.checkNumber5 && !!this.checkNumber6){
                    // 这个地方要调用验证码校验
                   this.$http.post('/valid/phoneCode',{
                       linkPhone: this.phoneNumbers,
                       smsVerificationCode: checkNumber
                   }).then((res) => {
                       if(res.data && res.data.code == 1){
                           this.active++;
                       }else{
                           this.$notify({
                               title: '短信验证码',
                               message: res.data.msg,
                               position: 'bottom-right',
                               type: 'warning'
                           })
                       }
                   })
                }else{
                    this.checkNumberRule = true;
                }
            },
            // 重新发送验证码
            againSendCode() {
                const timeCount = 60;
                this.$http.post('/register/getSms',{
                    linkPhone: this.phoneNumbers
                }).then((res) => {
                    if(res.data && res.data.code == 1){
                        this.isSend = false;
                        this.count = timeCount;
                        this.timer = setInterval(()=>{
                            if(this.count >0 && this.count <= timeCount){
                                this.count --;
                            }else{
                                this.isSend = true;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        },1000);
                        this.$notify({
                            title: '发送验证码',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'success'
                        })
                    }else{
                        this.$notify({
                            title: '发送验证码',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'warning'
                        })
                    }
                })
            },
            // 提交
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$http.post('/reset/password',{
                            id: this.actionId,
                            newPwd: this.form.pwd,
                            linkPhone: this.phoneNumbers
                        }).then((res) => {
                            if(res.data && res.data.code == 1){
                                this.result = true;
                                this.active++;
                            }else{
                                this.$notify({
                                    title: '重置密码',
                                    message: res.data.msg,
                                    position: 'bottom-right',
                                    type: 'warning'
                                })
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            // 账号输入监听
            checkInputRule() {
                if(!!this.input){
                    this.adopt = false;
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-input__suffix{
        right: 50px;
    }
    /deep/ .el-input__inner {
        width: 436px;
    }
    /deep/ .activeInput {
        .el-input__inner {
            border-color: #f56c6c;
        }
    }
    body{
        background: #F0F2F5;
        .box-card{
            width: 1300px;
            height: 792px;
            background: #FFFFFF;
            border: 1px solid #D8D8D8;
            margin: 74px auto 0;
            .Btn{
                margin-top: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                .btn-able{
                    opacity: 0.5;
                }
            }
            nav{
                width: 924px;
                margin: 0 auto;
            }
            main{
                .accountInformation{
                    width: 824px;
                    margin: 40px auto 0;
                    .accountInformation_title{
                        width: 824px;
                        height: 40px;
                        background: #EFF3F6;
                        p{
                            font-size: 18px;
                            font-family: MicrosoftYaHei;
                            color: #000000;
                            margin-left: 16px;
                            line-height: 40px;
                        }
                    }
                    span{
                        display: inline-block;
                        font-size: 14px;
                        font-family: MicrosoftYaHei;
                        color: rgba(0, 0, 0, 0.85);
                        margin-top: 36px;
                        margin-left: 16px;
                    }
                    .selectType{
                        margin-top: 24px;
                        margin-bottom: 25px;
                        margin-left: 16px;
                    }
                    .checkTip{
                        color: #f56c6c;
                        font-size: 12px;
                        margin-top: 4px;
                    }
                }
                .checkInformation{
                    width: 824px;
                    margin: 40px auto 0;
                    position: relative;
                    .checkInformation_title{
                        width: 824px;
                        height: 40px;
                        background: #EFF3F6;
                        p{
                            font-size: 18px;
                            font-family: MicrosoftYaHei;
                            color: #000000;
                            margin-left: 16px;
                            line-height: 40px;
                        }
                    }
                    span{
                        display: inline-block;
                        font-size: 14px;
                        font-family: MicrosoftYaHei;
                        color: rgba(0, 0, 0, 0.85);
                        margin-top: 36px;
                        margin-left: 16px;
                    }
                    .phoneNumber{
                        text-align: center;
                        span{
                            display: inline-block;
                            font-size: 24px;
                            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        input {
                            width: 40px;
                            height: 48px;
                            margin-left: 16px;
                            background: #FFFFFF;
                            border-radius: 4px;
                            border: 1px solid #D8D8D8;
                            text-align: center;
                        }
                        input:focus{
                            outline: none;
                        }
                    }
                    .phoneNumberRule{
                        color: #f56c6c;
                        font-size: 12px;
                        margin-top: 8px;
                        margin-left: 305px;
                    }
                    .checkNumberRule{
                        position: absolute;
                        color: #f56c6c;
                        font-size: 12px;
                        top: 138px;
                        left: 245px;
                    }
                }
                .changeformation{
                    width: 824px;
                    margin: 40px auto 0;
                    .changeformation_title{
                        width: 824px;
                        height: 40px;
                        background: #EFF3F6;
                        p{
                            font-size: 18px;
                            font-family: MicrosoftYaHei;
                            color: #000000;
                            margin-left: 16px;
                            line-height: 40px;
                        }
                    }
                    span{
                        display: inline-block;
                        font-size: 14px;
                        font-family: MicrosoftYaHei;
                        color: rgba(0, 0, 0, 0.85);
                        margin-top: 36px;
                        margin-left: 16px;
                    }
                }
                .resultPage{
                    width: 824px;
                    margin: 0 auto;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    span{
                        display: inline-block;
                        width: 72px;
                        height: 72px;
                        margin-top: 48px;
                    }
                    p{
                        font-size: 24px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: rgba(0, 0, 0, 0.85);
                        margin-top: 23px;
                    }
                    button{
                        width: 88px;
                        height: 32px;
                        margin-top: 48px;
                    }
                }
            }
        }
    }
</style>
